import { Routes, Route } from "react-router";
import { SessionProvider } from "./hooks/useSession";
import { Layout } from "./components/Layout/Layout";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Archive } from "./pages/Archive";

function App() {
  return (
    <SessionProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/archive/:id" element={<Archive />} />
        </Routes>
      </Layout>
    </SessionProvider>
  );
}

export default App;
